import React, {useEffect, useState} from 'react'
import {useCSVReader} from 'react-papaparse';
import {COLOR_LIST} from "../../../common/constants/color.constant";
import {PRODUCT_DETAIL_KEY, PRODUCT_FIELDS_LIST, PRODUCT_UPLOAD_TABS_LIST} from "../../constants/pod.constant";
import _ from "lodash";
import {
    prepareProductColors,
    prepareProductTypeAndCategories,
    prepareUploadedProductListWithFieldMapping
} from "../../utils/uploaded-product-data-util";

const UploadedProductTypes = ({
                                  podDetail,
                                  setPodDetail,
                                  setLatestProductsList,
                                  setLatestParentProductsList,
                                  setUploadedProducts,
                                  uploadedProductFields,
                                  uploadedProducts,
                                  productTypes,
                                  setProductTypes
                              }) => {
    const [initialStep, setInitialStep] = useState(true);

    useEffect(() => {
        if (!_.isEmpty(uploadedProducts)) {
            prepareProductTypes();
        }
    }, [initialStep]);

    const prepareProductTypes = () => {
        const uploadedProductsData = _.cloneDeep([...uploadedProducts]);
        const updatedProductList = prepareUploadedProductListWithFieldMapping(uploadedProductsData, uploadedProductFields, podDetail);
        setLatestProductsList(updatedProductList);

        const allDetail = prepareProductTypeAndCategories(updatedProductList, podDetail);
        setProductTypes(allDetail.productTypes);
        setLatestParentProductsList(allDetail.latestParentProducts);

        const existingPodDetail = {...podDetail};
        existingPodDetail.productTypesList = allDetail.productTypes;
        existingPodDetail.colors = allDetail.allColors;

        setPodDetail(existingPodDetail);
    }

    return (
        <>

            <div className="table-content-container overflow-y-scroll border-y border-gray-400 bg-white">
                <table className="w-full">
                    <thead className="">
                    <tr className="">
                        <th className="px-2 pb-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">Product
                            Type & Category
                        </th>
                        <th className="px-2 pb-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">Parent
                            Products
                        </th>
                        <th className="px-2 pb-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">Colors</th>
                        <th className="px-2 pb-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">Sizes</th>
                    </tr>
                    </thead>

                    <tbody className="">
                    {productTypes?.map((productType, productTypeIndex) => (
                        <React.Fragment key={`productType-${productTypeIndex}`}>

                            <tr className="border border-gray-400">
                                <td className="label-max text-blue-500 border border-gray-400 bg-gray-100" colSpan={4}>
                                    <div className="m-2">
                                        {productType?.name} <span
                                        className="font-normal">({productType?.total})</span>
                                    </div>
                                </td>
                            </tr>

                            {productType?.categories?.map((category, categoryIndex) => (
                                <tr key={`productType-${productTypeIndex}-category-${categoryIndex}`}
                                    className="border border-gray-400">
                                    <td className="border border-gray-400 w-96">
                                        <div className="label-max m-2">
                                            {category?.name} <span
                                            className="font-normal">({category?.total})</span>
                                        </div>
                                    </td>
                                    <td className="text-blue-500 border border-gray-400 w-1/4">
                                        <div className="text-gray-700 m-2">
                                            <div
                                                className={`mr-2 ${category?.totalParentProducts === 0 ? 'text-gray-400' : 'font-bold'}`}>Parent
                                                Products
                                                <span
                                                    className="text-gray-400 ml-1">({category?.totalParentProducts})</span>
                                            </div>
                                            <div>
                                                {category?.parentProducts?.map((parentProduct, parentProductIndex) => (
                                                    <div
                                                        key={`productType-${productTypeIndex}-category-${categoryIndex}-parentProduct-${parentProductIndex}`}
                                                        className="font-normal">{parentProduct?.name}
                                                        <span
                                                            className="text-gray-400 ml-1">({parentProduct?.total})</span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="text-blue-500 border border-gray-400">
                                        <div className="text-gray-700 m-2">
                                            <div
                                                className={`mr-2 ${category?.totalColors === 0 ? 'text-gray-400' : 'font-bold'}`}>Colors
                                                <span
                                                    className="text-gray-400 ml-1">({category?.totalColors})</span>
                                            </div>
                                            <div>
                                                {category?.colors?.map((color, colorIndex) => (
                                                    <span
                                                        key={`productType-${productTypeIndex}-category-${categoryIndex}-color-${colorIndex}`}
                                                        className="font-normal">{color?.name}, </span>
                                                ))}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="text-blue-500 border border-gray-400 w-1/4">
                                        <div className="text-gray-700 m-2">
                                            <div
                                                className={`mr-2 ${category?.totalSizes === 0 ? 'text-gray-400' : 'font-bold'}`}>Sizes
                                                <span
                                                    className="text-gray-400 ml-1">({category?.totalSizes})</span>
                                            </div>
                                            <div>
                                                {category?.sizes?.map((size, sizeIndex) => (
                                                    <span
                                                        key={`productType-${productTypeIndex}-category-${categoryIndex}-size-${sizeIndex}`}
                                                        className="font-normal">{size?.name}, </span>
                                                ))}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))}

                        </React.Fragment>
                    ))}
                    </tbody>
                </table>
            </div>

        </>
    )
}

export default UploadedProductTypes
